import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CalenderMonthPage } from './calender-month';

import { ComponentsModule } from '../components.module';

@NgModule({
  declarations: [
    CalenderMonthPage,
  ],
  imports: [
    ComponentsModule,
    IonicPageModule.forChild(CalenderMonthPage),
  ],
  exports: [
    CalenderMonthPage
  ]
})
export class CalenderMonthPageModule {}



// WEBPACK FOOTER //
// ./src/pages/calender-month/calender-month.module.ts